import {useState} from "react";

const usePopUpCtrl = () => {

    const [open, isOpen] = useState(false)
    const [cont, setCont] = useState('');

    function popHandler() {
        isOpen(prev => !prev)
    }

    function contHandler(msg = '') {
        setCont(msg)
    }

    return {
        open,
        cont,
        popHandler,
        contHandler,
    }

}

export default usePopUpCtrl